import { render, staticRenderFns } from "./d-post-form.vue?vue&type=template&id=270f04a4&"
import script from "./d-post-form.vue?vue&type=script&lang=js&"
export * from "./d-post-form.vue?vue&type=script&lang=js&"
import style0 from "./d-post-form.vue?vue&type=style&index=0&id=270f04a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports